// src/modules/app-views/goodsReceipt/pages/Init/actions/actionButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { PlusOutlined } from '@ant-design/icons';

// *******************************************************************************
// ACTION BUTTON
// *******************************************************************************
const goodsReceiptInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new',
    tooltip: 'new_goods_receipt',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,

    onClick: ({ navigate, setPage }) => {
      setPage({
        navigate,
        pageName: 'document',
        params: { _id: 'add' },
      });
    },

    dropdownItems: [],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default goodsReceiptInitActionButton;
